import { validate } from 'multicoin-address-validator';
import { validate as deprecatedValidate } from 'coinslot';
import config from '../../config';
var _config$CryptoAddress = config.CryptoAddressValidation,
  DoNotValidate = _config$CryptoAddress.DoNotValidate,
  ValidateAsERC20 = _config$CryptoAddress.ValidateAsERC20,
  UseDeprecatedValidate = _config$CryptoAddress.UseDeprecatedValidate;
var shouldNotValidate = function shouldNotValidate(productSymbol) {
  return DoNotValidate.includes(productSymbol);
};
var shouldValidateAsERC20 = function shouldValidateAsERC20(productSymbol) {
  return ValidateAsERC20.includes(productSymbol);
};
var shouldUseDeprecatedValidate = function shouldUseDeprecatedValidate(productSymbol) {
  return UseDeprecatedValidate.includes(productSymbol);
};
export default (function (productSymbol) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
  return function (address) {
    if (!productSymbol) return undefined;
    if (address === undefined) return undefined;
    if (shouldNotValidate(productSymbol)) return undefined;
    var format = function format(isValid) {
      return isValid ? undefined : errorMessage;
    };
    try {
      if (shouldUseDeprecatedValidate(productSymbol.toUpperCase())) {
        return format(deprecatedValidate(address, productSymbol.toUpperCase()));
      }
      if (shouldValidateAsERC20(productSymbol)) {
        return format(validate(address, 'ETH', 'both'));
      }
      return format(validate(address, productSymbol, 'both'));
    } catch (e) {
      /**
       * Currency not supported.
       */
      return undefined;
    }
  };
});